import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-bold font-heading text-background-50 mb-4">
              雏田同人馆
            </h4>
            <p className="text-sm text-background-300 leading-relaxed">
              专注火影忍者雏田角色同人创作的内容聚合平台，为粉丝提供最全面的雏田本子资源导览与推荐。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              内容分类
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/tongren-manhua" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">同人漫画</Link>
              <Link to="/category/chahua-zuopin" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">插画作品</Link>
              <Link to="/category/duanpian-tongren" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">短篇同人</Link>
              <Link to="/category/tongren-xiaoshuo" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">同人小说</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              快捷链接
            </h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">首页</Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
              <a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">投稿指南</a>
              <a href="#" className="text-sm text-background-300 hover:text-primary-400 transition-colors whitespace-nowrap">版权声明</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
              关注我们
            </h4>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 text-background-200 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="QQ">
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-secondary-700 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-400">
            &copy; {currentYear} 雏田同人馆 - 火影忍者雏田本子精选同人创作合集
          </p>
          <div className="flex items-center gap-4 text-sm text-background-400">
            <a href="#" className="hover:text-background-200 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-background-200 transition-colors">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}